import { Pipe, PipeTransform } from "@angular/core";

export function getOfferTermLabel(term: number): string {
  return `${term} ${term > 1 ? "months" : "month"}`;
}

@Pipe({
    name: "offerTermLabel",
    standalone: false
})
export class OfferTermLabelPipe implements PipeTransform {
  transform(term: number): string {
    return getOfferTermLabel(term);
  }
}
